import React from 'react'
import PropTypes from 'prop-types'


const facebook = require('./social-icons/facebook.svg')
const instagram = require('./social-icons/instagram.svg')
const twitter = require('./social-icons/twitter.svg')
const googlePlus = require('./social-icons/google-plus.svg')

const SocialIcon = props => {
    return (
        <div className="nrt-social-buttons">
            <div>
            {props.facebookUrl && (
                <a href={props.facebookUrl} target="_blank">
                    <img src={facebook} width="22px" />
                </a>
            )}
            {props.twitterUrl && (
                <a href={props.twitterUrl} target="_blank">
                    <img src={twitter} width="22px" />
                </a>
            )}
            {props.googlePlusUrl && (
                <a href={props.googlePlusUrl} target="_blank">
                    <img src={googlePlus} width="22px" />
                </a>
            )}
            {props.instagramUrl && (
                <a href={props.instagramUrl} target="_blank">
                    <img src={instagram} width="22px" />
                </a>
            )}
            </div>
        </div>
    )
}

SocialIcon.propTypes = {
    facebookUrl: PropTypes.string,
    twitterUrl: PropTypes.string,
    googlePlusUrl: PropTypes.string,
    instagramUrl: PropTypes.string,
}

export default SocialIcon



// WEBPACK FOOTER //
// ./src/components/_minha-central/Footer/SocialIcon.js